export class StripeIntent {
    id: string;
    amount: number;
    client_secret: string;
    constructor(intent?) {
        if (intent) {
            this.id = intent.id;
            this.amount = intent.addressLine1;
            this.client_secret = intent.client_secret;
        }
    }
}
